import { newsTagMainComponent } from "./news-tag-main.component";

export const newsTagMain = angular
  .module("components.news-tag.newsTagMain", [])
  .component("newsTagMain", newsTagMainComponent).name;



// WEBPACK FOOTER //
// ./src/app/components/news-tag/news-tag-main/news-tag-main.module.js